document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.indexOf("payment-details") === -1) {
    // only run this on the appropriate page
    return;
  }

  const addCardBtn = document.querySelector('#add-card-btn')
  const addCardFormEl = document.querySelector('#add-card')
  const listPaymentEl = document.querySelector('#list-payment')
  const cardNumberInput = document.querySelector(
    'input[name="form_fields[card_number]"]'
  )
  const expiryInput = document.querySelector(
    'input[name="form_fields[expiry_date]"]'
  )
  const cvvInput = document.querySelector(
    'input[name="form_fields[card_code]"]'
  )
  const addCardForm = document.querySelector('#add_payment')
  const titleList = document.querySelector(
    '#list-payment h2.kl-payment-title'
  )
  const inputsEl = document.querySelectorAll(
    '#add_payment .kl-payment-form-fields input'
  )


  let payments = []
  let userInfo = null
  let loadingPayments = false

  if (inputsEl) {
    inputsEl.forEach((i) => {
      i.addEventListener('input', function(e) {
        const msgError = e.target.nextElementSibling
        const formParent = e.target.parentElement.parentElement
        const formError = formParent.querySelector(
          '.kl-payment-form-actions .kl-message-danger'
        )
        if (
          msgError &&
          msgError.classList.contains('kl-message-danger')
        ) {
          msgError.remove()
        }
        if (formError) formError.remove()
      })
    })
  }

  function isExpired(dateStr) {
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const currentMonth = currentDate.getMonth() + 1

    const [inputMonth, inputYear] = dateStr.split('/').map(Number)
    const fullInputYear = inputYear + 2000

    if (
      fullInputYear < currentYear ||
      (fullInputYear === currentYear && inputMonth < currentMonth)
    ) {
      return true
    }
    return false
  }

  function validatePayment() {
    if (!cardNumberInput.value && !expiryInput.value && !cvvInput.value) return
    const cardNumberRegex = /^[0-9]{13,19}$/
    const cvvRegex = /^[0-9]{3,4}$/
    const msgEl = document.createElement('span')
    msgEl.classList.add('kl-message', 'kl-message-danger')

    if (
      cardNumberInput.value &&
      !cardNumberRegex.test(cardNumberInput.value.replace(/\s+/g, ''))
    ) {
      msgEl.textContent =
        'Invalid card number. It should be 13 to 19 digits long'
      setTimeout(() => {
        cardNumberInput.parentElement.appendChild(msgEl)
      }, 500)
      return false
    } else if (!cardNumberInput.value) return false

    if (expiryInput.value && isExpired(expiryInput.value)) {
      msgEl.textContent = 'The expiry date has expired.'
      setTimeout(() => {
        expiryInput.parentElement.appendChild(msgEl)
      }, 500)
      return false
    } else if (!expiryInput.value) return false

    if (cvvInput.value && !cvvRegex.test(cvvInput.value)) {
      msgEl.textContent = 'Invalid CVV. It should be 3 or 4 digits long.'
      setTimeout(() => {
        cvvInput.parentElement.appendChild(msgEl)
      }, 500)
      return false
    } else if (!cvvInput.value) {
      return false
    }

    msgEl.remove()
    return true
  }

  function getCardType(number) {
    const patterns = {
      visa: /^4/,
      mastercard: /^5[1-5]/,
      amex: /^3[47]/,
      discover: /^6(?:011|5)/,
      jcb: /^(?:352[89]|35[3-8][0-9])/
    }
    for (const card in patterns) {
      if (patterns[card].test(number)) {
        return card
      }
    }
    return 'unknown'
  }

  function updateCardIcon(value) {
    const cardIcon = document.querySelector('.icon-card')
    const cardType = getCardType(value)
    cardIcon.src = getBrand(cardType)
  }

  function getBrand(brand) {
    const cardType = brand?.toLowerCase()

    switch (cardType) {
      case 'visa':
        return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/visa-card.svg'
      case 'mastercard':
        return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/master-card.svg'
      case 'amex':
      case 'american_express':
        return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/amex-card.svg'
      case 'discover':
        return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/dis-card.svg'
      case 'jcb':
        return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/jcb-card.svg'
      default:
        return '/wp-content/plugins/klira-pro/assets/frontend/img/cards/icn-card.svg'
    }
  }

  function formatCardForm() {
    if (!cardNumberInput || !expiryInput || !cvvInput) return
    cardNumberInput.setAttribute('maxlength', '19')
    cardNumberInput.addEventListener('input', function(event) {
      const value = event.target.value.replace(/\D/g, '')
      let formattedValue = ''
      for (let i = 0; i < value.length; i += 4) {
        if (i > 0) {
          formattedValue += ' '
        }
        formattedValue += value.substring(i, i + 4)
      }
      event.target.value = formattedValue
      updateCardIcon(value)
    })

    expiryInput.addEventListener('input', function(event) {
      let value = event.target.value.replace(/\D/g, '')
      if (value.length > 4) {
        value = value.substring(0, 4)
      }
      if (value.length > 2) {
        value = value.slice(0, 2) + ' / ' + value.slice(2)
      }
      event.target.value = value
    })

    cvvInput.addEventListener('input', function(event) {
      let value = event.target.value.replace(/\D/g, '')
      if (value.length > 4) {
        value = value.substring(0, 4)
      }
      event.target.value = value
    })
  }

  function handleToggleMoreOptions() {
    const moreBtn = document.querySelectorAll('#kl-payment-wrapper .js-more')
    if (moreBtn?.length <= 0) return

    moreBtn.forEach((i) => {
      document.addEventListener('click', function(e) {
        const listOption = i.parentElement.querySelector(
          '.kl-card-more-options'
        )
        if (!listOption) return

        if (i.parentElement.contains(e.target)) {
          listOption.classList.toggle('more-active')
        } else {
          listOption.classList.remove('more-active')
        }
      })
    })
  }

  async function createPayment({ cardNumber, cvv, expMonth, expYear }) {
    try {
      const url = `/wp-json/klira/payment-method/store?_wpnonce=${wpApiSettings.nonce}`
      const formData = new FormData()
      const params = {
        number: cardNumber,
        cvv,
        'expire-year': expYear,
        'expire-month': expMonth,
        user_id: userInfo?.id
      }

      Object.keys(params).forEach((key) => {
        formData.append(key, params[key])
      })

      const response = await fetch(url, { method: 'POST', body: formData })
      const data = await response.json()
      if (!data) {
        const btnSubmit = document.querySelector('#submit-payment')
        const msgError = document.createElement('div')
        msgError.textContent = 'Failed to Create Payment'
        msgError.style.width = '100%'
        msgError.classList.add('kl-message', 'kl-message-danger')
        btnSubmit.parentElement.prepend(msgError)
        return false
      }
      return data
    } catch {
      return false
    }
  }

  async function setPrimaryPayment(paymentId) {
    try {
      const url = `/wp-json/klira/payment-method/set-primary?_wpnonce=${wpApiSettings.nonce}`

      const formData = new FormData()
      const params = { user_id: userInfo?.id, payment_id: paymentId }

      Object.keys(params).forEach((key) => {
        formData.append(key, params[key])
      })
      const response = await fetch(url, { method: 'POST', body: formData })
      const data = await response.json()
      return data
    } catch {
      return false
    }
  }

  async function deletePayment(paymentId) {
    try {
      const url = `/wp-json/klira/payment-method/remove-payment?_wpnonce=${wpApiSettings.nonce}`
      const formData = new FormData()
      formData.append('user_id', userInfo?.id)
      formData.append('payment_id', paymentId)
      const response = await fetch(url, { method: 'POST', body: formData })
      const data = await response.json()
      return data
    } catch {
      return false
    }
  }

  async function getListPayments() {
    loadingPayments = true
    try {
      const url = `/wp-json/klira/payment-method/get-list-payment?_wpnonce=${wpApiSettings.nonce}`
      const response = await fetch(url)
      const data = await response.json()
      if (!data) return []
      return data
    } catch {
      return []
    } finally {
      loadingPayments = false
    }
  }

  if (addCardBtn) {
    addCardBtn.addEventListener('click', function() {
      addCardFormEl.style.display = 'block'
      listPaymentEl.style.display = 'none'

      formatCardForm()
    })
  }

  // Test card auto-fill (buttons only exist on non-live environments)
  const testCardBtns = document.querySelectorAll('.kl-test-card-btn')
  testCardBtns.forEach((btn) => {
    btn.addEventListener('click', function() {
      const number = btn.dataset.number
      // Format the number with spaces every 4 digits
      const formatted = number.replace(/(.{4})/g, '$1 ').trim()
      cardNumberInput.value = formatted
      // Set a future expiry date
      const futureDate = new Date()
      futureDate.setFullYear(futureDate.getFullYear() + 2)
      const month = String(futureDate.getMonth() + 1).padStart(2, '0')
      const year = String(futureDate.getFullYear()).slice(-2)
      expiryInput.value = month + ' / ' + year
      // Set CVV (4 digits for Amex, 3 for others)
      cvvInput.value = btn.dataset.brand === 'amex' ? '1234' : '123'
      updateCardIcon(number)
    })
  })

  if (addCardForm) {
    addCardForm.addEventListener('submit', async function(e) {
      e.preventDefault()
      const cardNumber = cardNumberInput.value
      const expMonth = expiryInput.value?.split(' / ')?.[0]
      const expYear =
        String(new Date().getFullYear()).slice(0, 2) +
        expiryInput.value?.split(' / ')?.[1]
      const cvv = cvvInput.value
      if (!validatePayment()) return

      const status = await createPayment({ cardNumber, expMonth, expYear, cvv })
      updateCardIcon('')
      if (status) {
        addCardFormEl.style.display = 'none'
        listPaymentEl.style.display = 'block'
        showPaymentHTML()
      }
    })
  }

  function handleDeleteCard() {
    const deleteBtn = document.querySelectorAll('.js-delete')
    if (!deleteBtn) return

    deleteBtn.forEach((btn) => {
      btn.addEventListener('click', async function(e) {
        const loader = e.target.querySelector('.js-loader-delete')
        if (loader.style.display === 'block') return

        loader.style.display = 'block'
        const paymentId =
          e.target.parentElement.parentElement.parentElement.dataset.id
        const status = await deletePayment(paymentId)
        loader.style.display = 'none'
        if (status) showPaymentHTML()
      })
    })
  }

  function handleSetPrimary() {
    const primaryBtn = document.querySelectorAll('.js-set-primary')
    if (!primaryBtn) return

    primaryBtn.forEach((btn) => {
      btn.addEventListener('click', async function(e) {
        const loader = e.target.querySelector('.js-loader-primary')
        if (loader.style.display === 'block') return

        loader.style.display = 'block'
        const paymentId =
          e.target.parentElement.parentElement.parentElement.dataset.id
        const status = await setPrimaryPayment(paymentId)
        loader.style.display = 'none'
        if (status) showPaymentHTML()
      })
    })
  }

  function skeletonPayments() {
    const paymentList = document.querySelector('.kl-payment-list')

    const skeletonCardItem = `
		  <div class="kl-payment-item">
		    <div class="kl-card-info">
			  <div class="skeleton" style="width: 70px"></div>
			  <div class="kl-card-desc" style="width: 156px">
			    <div class="skeleton" style="height: 26px; margin-bottom: 10px"></div>
				<div class="skeleton" style="height: 30px;"></div>
			  </div>
			</div>
			<div class="skeleton" style="width:30px;height:20px"></div>
		  </div>
		`

    if (loadingPayments) paymentList.innerHTML = skeletonCardItem
  }

  async function showPaymentHTML() {
    const paymentWrapper = document.querySelector('#kl-payment-wrapper')
    if (!paymentWrapper) return
    if (paymentWrapper) paymentWrapper.innerHTML = null
    const paymentList = document.createElement('div')
    paymentList.classList.add('kl-payment-list')
    paymentWrapper.appendChild(paymentList)

    loadingPayments = true
    skeletonPayments()

    payments = await getListPayments()

    if (!payments || !payments.length) {
      titleList.textContent = `payment method`
      paymentList.innerHTML = `
				<div class="kl-payments">
					<div class="kl-payment-heading">
						<h2>Your card list is currently empty.</h2>
					</div>
				</div>
			`
      return
    }

    titleList.textContent = `payment method (${payments?.length})`
    paymentList.innerHTML = `
			<div class="kl-payments">
				${payments
          ?.map((payment) => {
            return `
					  <div class="kl-payment-item" data-id="${payment.id}">
							<div class="kl-card-info">
								<img src="${getBrand(payment.brand)}" alt="${payment.brand}" />
								<div class="kl-card-desc">
									<p class="kl-card-name">${payment.last4 ? `${payment.brand} ending ${payment.last4}` : payment.masked_number}</p>
									${payment.expiry_month ? `<p class="kl-card-date">
									Expire date: ${payment.expiry_month}/${payment.expiry_year}</p>` : ''}
									${payment.primary ? '<div class="kl-card-label">Primary</div>' : ''}
								</div>
							</div>

							${
                payments.length > 1
                  ? `<div class="kl-card-more">
								<div class="kl-more-icon js-more">
									<img src="/wp-content/plugins/klira-pro/assets/frontend/img/cards/icn-more.svg" alt="more icon" />
								</div>

								<ul class="kl-card-more-options">
									${
                    !payment.primary
                      ? `<li class="kl-card__set-primary js-set-primary">
										<span class="kl-loader js-loader-primary" style="display: none"></span> Set as primary</li>`
                      : ''
                  }
									<li class="kl-card__delete js-delete"> <span class="kl-loader js-loader-delete" style="display: none"></span> Delete</li>
								</ul>
							</div>`
                  : ''
              }

						</div>
					`
          })
          .join('')}
			</div>
		`

    handleToggleMoreOptions()
    handleSetPrimary()
    handleDeleteCard()
  }

  function initPayment() {
    const stored = localStorage.getItem('user-details')
    userInfo = stored ? JSON.parse(stored) : null

    showPaymentHTML()
  }

  initPayment()
})
